/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["gece", "ö", "sabah", "öğleden önce", "öğleden sonra", "akşamüstü", "akşam", "gece"], ["gece yarısı", "öğle", "sabah", "öğleden önce", "öğleden sonra", "akşamüstü", "akşam", "gece"], u], [["gece yarısı", "öğle", "sabah", "öğleden önce", "öğleden sonra", "akşamüstü", "akşam", "gece"], u, u], ["00:00", "12:00", ["06:00", "11:00"], ["11:00", "12:00"], ["12:00", "18:00"], ["18:00", "19:00"], ["19:00", "21:00"], ["21:00", "06:00"]]];
